import { Component, Input, OnInit } from '@angular/core';
import { SettingsService } from '../../../../_services/api/settings.service';
import { RestResponse } from 'src/app/_shared/models';
import { CompanyNotification } from 'src/app/_shared/models/notifications.model';
import { MetaService } from 'src/app/_core/services/meta.service';

@Component({
  selector: 'app-notification-item',
  templateUrl: './notification-item.component.html',
  styleUrls: ['./notification-item.component.scss']
})
export class NotificationItemComponent implements OnInit {
  @Input() notification: any;
  @Input() title: any;
  @Input() subtitle: any;
  @Input() _notificationSectionKeyName: string;
  @Input() actionDisabled = false;

  @Input() isReady = false;
  notifications = [];
  loading: boolean;
  iconDown = false;
  constructor(
    private _meta: MetaService,
    private settingsService: SettingsService
  ) { }

  ngOnInit(): void {
  }

  click() {
    this.iconDown = !this.iconDown;
  }

  getNotificationsByKeyName() {
    this.loading = true;
    this.settingsService.getNotificationByKeyName(this._notificationSectionKeyName).subscribe(
      (res: RestResponse) => {
        this.notifications = <Array<CompanyNotification>>res.data;
        this.loading = false;
      },
      (err: RestResponse) => {
        this.loading = false;
        this._meta.showNotification(err);
      }
    );
  }
}
